<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import type { IconType } from "$components/+blocks/OVIcon/OVIcon";
  import type { ButtonHTMLType } from "../IconButton.svelte";

  export let icon: IconType;
  export let a11yLabel: string;
  export let ariaRole: "link" | undefined = undefined;
  export let disabled: boolean = false;
  export let customIconSize: string | undefined = undefined;
  export let htmlButtonType: ButtonHTMLType = "button";

  let className: string = "";
  export { className as class };

  let element: HTMLButtonElement;
</script>

<!-- button base doesn't control styling (done in IconButton.svelte), it only takes care of underlying button functionality -->
<button
  bind:this={element}
  aria-label={a11yLabel}
  class={className}
  {disabled}
  on:click
  type={htmlButtonType}
  role={ariaRole}
  on:keydown={(e) => {
    if (e.key === "Tab") {
      element.blur();
    }
  }}
>
  <OVIcon {icon} size={customIconSize} />
</button>
